import { Tag, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SlimTag } from '@texas/api/endpoints/tagsApi';
import { formatDate } from '@texas/utils/helpers/dateHelper';
import { Locale } from '@texas/i18n/types';

interface TagWithTooltipProps {
  tag: SlimTag;
}

export function TagWithTooltip({ tag }: TagWithTooltipProps) {
  const { t } = useTranslation();

  const tooltipLabel = tag.addedByUserName
    ? t('tags.addedByOn', {
        userName: tag.addedByUserName,
        date: formatDate(Locale.En, tag.added),
      })
    : t('tags.addedOn', {
        date: formatDate(Locale.En, tag.added),
      });

  return (
    <Tooltip label={tooltipLabel} isDisabled={!tooltipLabel}>
      <Tag bg={tag.color} color="white" fontWeight="bold" size="sm">
        {tag.label}
      </Tag>
    </Tooltip>
  );
}
